/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Box, CardContent, Grid, Typography, Table, TableBody, TableCell, TableRow, LinearProgress } from '@mui/material';


import moment from 'moment';


const BAR_HEIGHT = 12;
const BAR_SPACING = 0;

interface ProjectDetailsSummaryBodyProps {
    summary: any
}

export const ProjectDetailsSummaryBody: React.FC<ProjectDetailsSummaryBodyProps> = ({ summary }) => {

    const fmt = (val: number) => Intl.NumberFormat('en-US').format(val || 0);

    // eslint-disable-next-line no-unreachable
    return (

        <CardContent sx={{ pt: 2, pb: '16px !important' }}>

            <Table size="small" sx={{ mb: 2 }}>
                <TableBody>
                    <TableRow sx={{ '& td': { borderBottom: 'none', px: 1, py: 0 } }}>
                        <TableCell align="center">
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Typography variant="caption" color="textSecondary" sx={{ fontSize: 11 }}>
                                    Monto({summary.Moneda}){' '}{fmt(summary.MontoContrato)}
                                </Typography>
                            </Box>
                        </TableCell>
                        <TableCell align="center">
                            {<Box display="flex" flexDirection="column" alignItems="center">
                                <Typography variant="body2">
                                    {summary.FechaInicioReal ? moment(summary.FechaInicioReal).format('DD/MM/YYYY') : '--/--/----'} - {summary.FechaFinReal ? moment(summary.FechaFinReal).format('DD/MM/YYYY') : '--/--/----'}
                                </Typography>
                            </Box>}
                        </TableCell>
                        <TableCell align="center">
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Typography variant="body2">({summary.ReporteA || '-'})</Typography>
                            </Box>
                        </TableCell>
                        <TableCell align="center">
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Typography variant="caption" color="textSecondary" sx={{ fontSize: 11 }}>
                                    Procesado: {summary.FechaProcesoRO ? moment(summary.FechaProcesoRO).format('DD/MM/YYYY HH:mm:ss') : '-'}
                                </Typography>
                            </Box>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>

            <Grid container spacing={.5} sx={{ mb: 2 }} alignItems="flex-start">
                <Grid item xs={2.4}>
                    <Box textAlign="center" display="flex" flexDirection="column" alignItems="center">
                        <Box display="flex" alignItems="center">
                            <Box component="span" sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#2e86c1', mr: 1 }} />
                            <Typography variant="caption" fontWeight="bold">Programado</Typography>
                        </Box>
                        <Typography variant="caption" display="block">{fmt(summary.Programado)}</Typography>
                        <Typography variant="caption" display="block">{summary.PorcentajeProgramado}%</Typography>
                    </Box>
                </Grid>
                <Grid item xs={2.4}>
                    <Box textAlign="center" display="flex" flexDirection="column" alignItems="center">
                        <Box display="flex" alignItems="center">
                            <Box component="span" sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#f1c40f', mr: 1 }} />
                            <Typography variant="caption" fontWeight="bold">Valorizado</Typography>
                        </Box>
                        <Typography variant="caption" display="block" color={(summary.PorcentajeFA) < 0 ? 'error.main' : 'success.main'}>{fmt(summary.Valorizado)}</Typography>
                        <Typography variant="caption" display="block" color={(summary.PorcentajeFA) < 0 ? 'error.main' : 'success.main'}>{summary.PorcentajeValorizado}%</Typography>
                    </Box>
                </Grid>
                <Grid item xs={2.4}>
                    <Box textAlign="center" display="flex" flexDirection="column" alignItems="center">
                        <Box display="flex" alignItems="center">
                            <Box component="span" sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#1abc9c', mr: 1 }} />
                            <Typography variant="caption" fontWeight="bold">Real</Typography>
                        </Box>
                        <Typography variant="caption" display="block" color={(summary.PorcentajeFC) < 0 ? 'error.main' : 'success.main'}>{fmt(summary.Real)}</Typography>
                        <Typography variant="caption" display="block" color={(summary.PorcentajeFC) < 0 ? 'error.main' : 'success.main'}>{summary.PorcentajeReal}%</Typography>
                    </Box>
                </Grid>
                <Grid item xs={2.4}>
                    <Box textAlign="center">
                        <Typography variant="caption" fontWeight="bold">Fa</Typography>
                        <Typography variant="caption" display="block" color={(summary.PorcentajeFA) < 0 ? 'error.main' : 'success.main'}>{summary.FA}</Typography>
                        <Typography variant="caption" display="block" color={(summary.PorcentajeFA) < 0 ? 'error.main' : 'success.main'}>{summary.PorcentajeFA}%</Typography>
                    </Box>
                </Grid>
                <Grid item xs={2.4}>
                    <Box textAlign="center">
                        <Typography variant="caption" fontWeight="bold">Fc</Typography>
                        <Typography variant="caption" display="block" color={(summary.PorcentajeFC) < 0 ? 'error.main' : 'success.main'}>{summary.FC}</Typography>
                        <Typography variant="caption" display="block" color={(summary.PorcentajeFC) < 0 ? 'error.main' : 'success.main'}>{summary.PorcentajeFC}%</Typography>
                    </Box>
                </Grid>
            </Grid>

            <Box>
                <Box display="flex" alignItems="center" mb={`${BAR_SPACING}px`}>
                    <Box width="100%" mr={1}>
                        <LinearProgress variant="determinate" value={Math.min(summary.PorcentajeProgramado, 100)} sx={{ height: BAR_HEIGHT, borderRadius: BAR_HEIGHT / 2, bgcolor: '#e0e0e0', '& .MuiLinearProgress-bar': { bgcolor: '#2e86c1' } }} />
                    </Box>
                    <Typography variant="caption" color="textSecondary">{summary.PorcentajeProgramado}%</Typography>
                </Box>
                <Box display="flex" alignItems="center" mb={`${BAR_SPACING}px`}>
                    <Box width="100%" mr={1}>
                        <LinearProgress variant="determinate" value={Math.min(summary.PorcentajeValorizado, 100)} sx={{ height: BAR_HEIGHT, borderRadius: BAR_HEIGHT / 2, bgcolor: '#e0e0e0', '& .MuiLinearProgress-bar': { bgcolor: '#f1c40f' } }} />
                    </Box>
                    <Typography variant="caption" color="textSecondary">{summary.PorcentajeValorizado}%</Typography>
                </Box>
                <Box display="flex" alignItems="center">
                    <Box width="100%" mr={1}>
                        <LinearProgress variant="determinate" value={Math.min(summary.PorcentajeReal, 100)} sx={{ height: BAR_HEIGHT, borderRadius: BAR_HEIGHT / 2, bgcolor: '#e0e0e0', '& .MuiLinearProgress-bar': { bgcolor: '#1abc9c' } }} />
                    </Box>
                    <Typography variant="caption" color="textSecondary">{summary.PorcentajeReal}%</Typography>
                </Box>
            </Box>
        </CardContent>
    );
};